document.addEventListener('DOMContentLoaded', ()=>{

    new Swiper('.desktop-banner-swiper', {
      slidesPerView: 1,
      loop: true,
      pagination: { el: '.desktop-pagination', clickable: true },
    });
  
    new Swiper('.mobile-banner-swiper', {
      slidesPerView: 1,
      loop: true,
      pagination: { el: '.mobile-pagination', clickable: true },
    });  



    // Add to cart js 


    document.addEventListener('DOMContentLoaded', function () {
        console.log('✅ Custom Add to Cart JS Loaded');
    
        document.addEventListener('submit', async function (e) {
          const form = e.target.closest('form[data-productid]');
          if (!form) return;
    
          e.preventDefault();
    
          const btn =
            form.querySelector('button:focus') ||
            form.querySelector('button[data-last-clicked="true"]') ||
            form.querySelector('button');
    
          // If button is locked → block this button only
          if (btn.dataset.locked === 'true') {
            console.warn('⛔ Blocked duplicate submit for this BUTTON');
            return;
          }
    
          // Lock ONLY the clicked button
          btn.dataset.locked = 'true';
    
          const loader = btn.querySelector('[data-loader]');
          const text = btn.querySelector('.add_to_cart');
          const variantId = form.querySelector('input[name="id"]').value.trim();
    
          // Loader ON
          if (text) text.style.display = 'none';
          if (loader) loader.classList.remove('hide'), loader.classList.add('show');
    
          try {
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();
            const existingItem = cart.items.find((item) => item.variant_id == variantId);
    
            if (existingItem) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: existingItem.key, quantity: 0 }),
              });
            }
    
            let addRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({ id: variantId, quantity: 1 }),
            });
    
            if (!addRes.ok) throw new Error(await addRes.text());
    
            openCartDrawer();
          } catch (err) {
            console.error('❌ ERROR:', err);
          } finally {
            // Unlock **only this button**
            btn.dataset.locked = 'false';
    
            if (loader) loader.classList.add('hide'), loader.classList.remove('show');
            if (text) text.style.display = '';
          }
        });
    
        function openCartDrawer() {
          fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((res) => res.text())
            .then((htmlText) => {
              const html = new DOMParser().parseFromString(htmlText, 'text/html');
              const updatedDrawer = html.querySelector('#CartDrawer');
    
              if (updatedDrawer && document.querySelector('#CartDrawer')) {
                document.querySelector('#CartDrawer').innerHTML = updatedDrawer.innerHTML;
    
                const drawer = document.querySelector('cart-drawer.cartDrawer__mainlayout');
                if (drawer) drawer.classList.add('active', 'animate');
    
                document.body.classList.add('overflow-hidden');
              }
            });
        }
      });




    //   product slider 

    let init = false;
    let swiper;

    function swiperCard() {
      if (window.innerWidth < 768) {
        if (!init) {
          init = true;

          swiper = new Swiper('.Bannercollection-swiper', {
            direction: 'horizontal',
            slidesPerView: 1.8,
            initialSlide: 0,
            spaceBetween: 15,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },

            breakpoints: {
              1024: {
                slidesPerView: 5,
                initialSlide: 0,
                spaceBetween: 18,
                loop: false,
              },

              750: {
                loop: false,
                slidesPerView: 1.8,
                initialSlide: 0,
                spaceBetween: 15,
                freeMode: true,
              },

              640: {
                loop: false,
                slidesPerView: 1.8,
                initialSlide: 0,
                spaceBetween: 15,
                freeMode: true,
              },

              414: {
                loop: false,
                slidesPerView: 2.4,
                initialSlide: 0,
                spaceBetween: 15,
                freeMode: true,
              },

              375: {
                loop: false,
                slidesPerView: 1.8,
                initialSlide: 0,
                spaceBetween: 15,
                freeMode: true,
              },

              320: {
                loop: false,
                slidesPerView: 1.8,
                initialSlide: 0,
                spaceBetween: 15,
                freeMode: true,
              },
            },
          });
        }
      } else {
        if (init && swiper) {
          swiper.destroy(true, true);
          init = false;
        }
      }
    }

    swiperCard();
    window.addEventListener('resize', swiperCard);


});  